import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const setPlayerRateOnRoundAtom = atom(
  null,
  (
    get,
    set,
    {
      roundId,
      rate,
      isTargetingAll,
      targetRoundIds,
    }: {
      roundId: string;
      rate: { id: string };
      isTargetingAll: boolean;
      targetRoundIds?: string[];
    }
  ) => {
    const booking = get(currentBookingAtom);
    if (!booking) return;
    const targetRoundIdSet =
      isTargetingAll && targetRoundIds ? new Set(targetRoundIds) : null;

    const getUpdatedRate = (
      existingRate:
        | { id: string; name?: string; isLocked?: boolean }
        | null
        | undefined
    ) => {
      if (existingRate?.id === rate.id) {
        return { ...existingRate, ...rate };
      }

      return rate;
    };

    const updatedRounds = booking.rounds.map((round) => {
      if (
        (isTargetingAll
          ? targetRoundIdSet?.has(round.localId) ?? false
          : round.localId === roundId) &&
        !(round.type === "Golf"
          ? round.roundRate?.isLocked
          : round.rate?.isLocked)
      ) {
        return {
          ...round,
          ...(round.type === "Golf"
            ? { roundRate: getUpdatedRate(round.roundRate) }
            : { rate: getUpdatedRate(round.rate) }),
        };
      }
      return round;
    });
    const newBooking = {
      ...booking,
      rounds: updatedRounds,
    };
    set(currentBookingAtom, newBooking);
  }
);
